var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { factory } from "typescript";
export var createSelfClosingJsxRouteElement = function (newPageName) {
    return factory.createJsxSelfClosingElement(factory.createIdentifier("Route"), undefined, factory.createJsxAttributes([
        factory.createJsxAttribute(factory.createIdentifier("path"), factory.createStringLiteral("/" + newPageName)),
        factory.createJsxAttribute(factory.createIdentifier("component"), factory.createJsxExpression(undefined, factory.createIdentifier(newPageName))),
    ]));
};
export var createOpeningAndClosingJsxRouteElement = function (newPageName) {
    var newOpeningNode = factory.createJsxOpeningElement(factory.createIdentifier("Route"), undefined, factory.createJsxAttributes([
        factory.createJsxAttribute(factory.createIdentifier("path"), factory.createStringLiteral("/" + newPageName)),
        factory.createJsxAttribute(factory.createIdentifier("component"), factory.createJsxExpression(undefined, factory.createIdentifier(newPageName))),
    ]));
    var newClosingNode = factory.createJsxClosingElement(factory.createIdentifier("Route"));
    return [newOpeningNode, newClosingNode];
};
export var wrapNodesWithFragment = function (node, newNodes) {
    return factory.createJsxFragment(factory.createJsxOpeningFragment(), __spreadArray([node], newNodes), factory.createJsxJsxClosingFragment());
};
export var createEmptySpanElement = function () {
    return factory.createJsxElement(factory.createJsxOpeningElement(factory.createIdentifier("span"), undefined, factory.createJsxAttributes([])), [], factory.createJsxClosingElement(factory.createIdentifier("span")));
};
